import * as React from 'react'
function SvgSearch(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M27.906 25.27c1.694-2.258 2.635-4.894 2.635-7.905C30.541 10.024 24.706 4 17.365 4S4 10.024 4 17.365c0 7.34 6.024 13.364 13.365 13.364 3.011 0 5.835-.94 7.906-2.635l5.647 5.647c.376.377.94.565 1.317.565s.941-.188 1.318-.565c.753-.753.753-1.882 0-2.635l-5.647-5.835zm-10.541 1.506c-5.27 0-9.6-4.14-9.6-9.411 0-5.27 4.33-9.6 9.6-9.6s9.6 4.33 9.6 9.6-4.33 9.411-9.6 9.411z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgSearch
